module.exports = __webpack_public_path__ + "static/image24@2x-c8cb0d1bba6b2393a9ea063fbbdf5ce9.png";